
<div class="container">
 
  <div class="containerLogin login-container">
    <form [formGroup]="loginInformation" (ngSubmit)="onSubmit()">

      <div class="col-md-12 login-form-1">
        <a href="/" class="btn btn-primary">Exit to Return to the Settlement Website</a>
        <br />
        <br />

        <h3 class="misc-titles text-center">Drug Search Tool</h3>
        <div class="container" style="border:1px solid #bebaba">
          <br /><br />
          <div class="form-group">
            <div class="row">
              <div class="col-md-12">
                <label for="drugName" style="font-weight:bold">Enter Drug Name: <span style="color:red" class="required"> *</span></label>
                <input type="text" class="form-control" formControlName="drugName" trim="blur" autocomplete="off"
                       [ngClass]="{ 'is-invalid': submitted && f.drugName.errors }" />
                <div *ngIf="submitted && f.drugName.errors" class="invalid-feedback">
                  <div *ngIf="f.drugName.errors.required">This field is required</div>
                  <div *ngIf="f.drugName.errors.minlength">This field must be at least 8 characters</div>
                  <div *ngIf="f.drugName.errors.maxlength">
                    This field must not be greater than 8 characters
                  </div>
                  <div *ngIf="f.drugName.errors.pattern">This field accepts only numerical digits 0-9 and characters A-Z</div>
                </div>
              </div>
            </div>
          </div>
          <br /><br />
          <div class="row">
            <div class="col-md-12 text-center">
              <div class="form-group">
                <button class="btn btn-primary" id="login" [disabled]="clicked">Submit</button>
              </div>
            </div>
          </div>
          <div class="row mt-3" *ngIf="showDivInClass == true">
            <div class="col-md-12 text-center" style="font-weight:bold; color:red; font-size:2.0em">
              <b>Drug Found</b><br/><br/>

              This drug is included in the Settlement and may be eligible under the class action. Please review the applicable criteria and submit a claim if you believe you qualify.
            </div>
          </div>
          <div class="row mt-3" *ngIf="showDivNotInClass == true">
            <div class="col-md-12 text-center" style="font-weight:bold; color:red; font-size:2.0em">
              <b>Drug Not Found</b><br/><br/>

              This drug does not appear on the list of products currently included in the Settlement. If you believe this result is incorrect, please review the complete drug list here or contact the Settlement Administrator for assistance.
            </div>
          </div>
          <br />
          <br />
        </div>
        <br />
      </div>


    </form>
    <ngx-spinner bdColor="rgba(51,51,51,0.8)"
                 size="medium"
                 color="#fff"
                 type="ball-scale-multiple">
      <p style="font-size: 20px; color: white">Loading...</p>
    </ngx-spinner>
  </div>
</div>
